import { Component, OnInit } from '@angular/core';
import { ConfigService } from './config.service';
import { GoogleAnalyticsService, SessionManagerService, AppName, PendoService } from '@pubmatic/ui-core';
import { OktaAuthService } from '@okta/okta-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isAuthenticated: boolean;

  constructor(
    private config: ConfigService,
    private ga: GoogleAnalyticsService,
    private sm: SessionManagerService,
    public oktaAuth: OktaAuthService
  ) {
    if (config.gaEnabled) {
      const gaTrackingCode = this.getGaTrackingCode();
      if (!gaTrackingCode) {
        throw new Error(('No tracking code found for GA'));
      }
      ga.ga('create', gaTrackingCode, 'auto');
      ga.startTracking();
    }
    // subscribe to authentication state changes
    this.oktaAuth.$authenticationState.subscribe(
      (isAuthenticated: boolean) => this.isAuthenticated = isAuthenticated
    );
  }

  getGaTrackingCode() {
    let trackingCode = this.config.gaTrackingCode;
    const appName: AppName = this.sm.getAppName();
    if (appName && typeof trackingCode === 'object') {
      trackingCode = this.config.gaTrackingCode[appName];
    }
    return trackingCode;
  }

  async ngOnInit(): Promise<void> {
    // get authentication state for immediate use
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
  }

  async login(): Promise<void> {
    await this.oktaAuth.signInWithRedirect();
  }

  async logout(): Promise<void> {
    await this.oktaAuth.signOut();
  }
}
